import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getSupplierActivationStatus } from 'entities/CatalogItem';
import { Proposal } from 'entities/Proposal/model/types/ProposalSchema';
import {
    VendorActivationStatus,
    getPropertyVendorsMap,
} from 'entities/Vendors';

export const useProposalsStatus = (
    fullProposals: Proposal[],
): VendorActivationStatus | null => {
    const vendorsMap = useSelector(getPropertyVendorsMap);
    return useMemo(() => {
        let hasPending = false;
        for (const proposal of fullProposals) {
            const status = getSupplierActivationStatus(proposal, vendorsMap);
            if (status === VendorActivationStatus.INVALID) {
                return VendorActivationStatus.INVALID;
            }
            if (status === VendorActivationStatus.VERIFYING) {
                hasPending = true;
            }
        }
        return hasPending ? VendorActivationStatus.VERIFYING : null;
    }, [fullProposals, vendorsMap]);
};
